import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { Html } from "@react-three/drei";
import * as THREE from "three";
import { Board } from "./board";
import { AnimatedBoard } from "./animate";
export const RenderLayout = ({ struct, onColorChange, palette, onPaletteChange, isEditor = false, onGroupClick, animationPlaying = false, animEpoch = 0 }) => {
    const [activeGroup, setActiveGroup] = useState(null);
    const [menuPosition, setMenuPosition] = useState([0, 0, 0]);
    const [hoveredGroup, setHoveredGroup] = useState(null);
    const groupRefs = useRef([]);
    const addToPalette = (hex) => {
        if (palette.includes(hex))
            return;
        onPaletteChange([hex, ...palette].slice(0, 16));
    };
    const handleColorChange = (groupIndex, hex) => {
        applyColor(groupIndex, hex);
        addToPalette(hex);
    };
    const setHover = (index, prevIndex) => {
        const applyHover = (groupIndex, active) => {
            if (groupRefs.current[groupIndex]) {
                groupRefs.current[groupIndex].traverse((child) => {
                    if (child.isMesh) {
                        const mesh = child;
                        if (!mesh.userData.cloned) {
                            mesh.material = mesh.material.clone();
                            mesh.userData.cloned = true;
                        }
                        const mat = mesh.material;
                        mat.emissive?.set(active ? '#4488ff' : '#ffffff');
                        mat.emissiveIntensity = active ? 0.4 : 0;
                        mat.needsUpdate = true; // ← добавь это
                    }
                });
            }
        };
        if (prevIndex !== null)
            applyHover(prevIndex, false);
        if (index !== null)
            applyHover(index, true);
        setHoveredGroup(index);
        document.body.style.cursor = index !== null ? 'pointer' : 'auto';
    };
    const applyColor = (groupIndex, hex) => {
        // меняем визуально через traverse
        if (groupRefs.current[groupIndex]) {
            groupRefs.current[groupIndex].traverse((child) => {
                if (child.isMesh) {
                    const mat = child.material;
                    mat.color.set(hex);
                    mat.needsUpdate = true;
                }
            });
        }
        onColorChange(groupIndex, hex);
    };
    const handleGroupClick = (e, index, data) => {
        e.stopPropagation();
        if (onGroupClick) {
            onGroupClick?.(index, data);
        }
        else {
            setActiveGroup(prev => prev === index ? null : index); // toggle
            setMenuPosition([e.point.x, e.point.y, e.point.z]);
        }
    };
    return (_jsx(_Fragment, { children: struct.map((data, i) => (_jsxs("group", { name: data.group, onClick: isEditor ? (e) => {
                e.stopPropagation();
                handleGroupClick(e, i, data);
            } : undefined, ref: (el) => (groupRefs.current[i] = el), onPointerMissed: isEditor ? () => setActiveGroup(null) : undefined, onPointerOver: isEditor ? (e) => {
                e.stopPropagation();
                setHover(i, hoveredGroup);
            } : undefined, onPointerOut: isEditor ? (e) => {
                e.stopPropagation();
                setHover(null, i);
            } : undefined, position: data.position ?? [0, 0, 0], rotation: data.rotation ? new THREE.Euler(...data.rotation) : undefined, children: [data.elements.map((element, j) => (element.animation ? (_jsx(AnimatedBoard, { name: element.name, position: element.position, rotation: element.rotation, material: data.material[element.material], vertices: data.vertices[element.vertices], uvs: data.uvs[element.uvs], indices: data.indices[element.indices], playing: animationPlaying, animation: element.animation, animEpoch: animEpoch }, element.name + j)) : (_jsx(Board, { name: element.name, position: element.position, rotation: element.rotation, material: data.material[element.material], vertices: data.vertices[element.vertices], uvs: data.uvs[element.uvs], indices: data.indices[element.indices] }, element.name + j)))), isEditor && activeGroup === i && (_jsx(Html, { position: menuPosition, style: { pointerEvents: 'auto' }, children: _jsxs("div", { style: {
                            background: 'white',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            padding: '12px',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                            minWidth: '200px',
                            fontSize: '14px'
                        }, onPointerDown: (e) => e.stopPropagation(), onClick: (e) => e.stopPropagation(), children: [_jsx("div", { style: { fontWeight: 'bold', marginBottom: 10 }, children: "\uD83C\uDFA8 Material" }), _jsx("div", { style: { display: 'flex', gap: 5, marginBottom: 10, flexWrap: 'wrap' }, children: palette.map((hex, idx) => (_jsx("div", { onClick: () => handleColorChange(i, hex), title: hex, style: {
                                        width: 28,
                                        height: 28,
                                        borderRadius: 6,
                                        background: hex,
                                        cursor: 'pointer',
                                        border: '2px solid #ccc',
                                        transition: 'transform 0.1s',
                                        flexShrink: 0
                                    }, onMouseEnter: e => (e.currentTarget.style.transform = 'scale(1.2)'), onMouseLeave: e => (e.currentTarget.style.transform = 'scale(1)') }, hex + idx))) }), _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 8 }, children: [_jsx("label", { style: { color: '#666', fontSize: 12 }, children: "Custom color:" }), _jsx("input", { type: "color", defaultValue: "#8c4d24", onChange: (e) => applyColor(i, e.target.value), onBlur: (e) => addToPalette(e.target.value), style: { width: 40, height: 28, cursor: 'pointer', border: 'none' } })] }), _jsx("div", { style: { marginTop: 10, cursor: 'pointer', color: '#999', fontSize: 12 }, onClick: () => setActiveGroup(null), children: "\u2716 Close" })] }) }))] }, i))) }));
};
